module.exports = __webpack_public_path__ + "static/media/christian_lo.dc4bfce5.png";